<div class="my-comments-layout">
  <a routerLink="/dashboard" class="back-link">
    <i class="bi bi-arrow-left"></i> Back to Dashboard
  </a>

  <h1 class="page-title">My Comments</h1>
  <p class="page-subtitle">View all questions you have commented on. Filter by course and subject to narrow down the results.</p>

  <!-- Filter panel -->
  <div class="panel filter-panel">
    <label class="panel-label">Filters</label>
    <div class="filter-row">
      <div class="filter-group">
        <label class="filter-label">Course</label>
        <select class="form-select" [(ngModel)]="selectedCourseId" (change)="onCourseChange()" [disabled]="isLoadingCourses">
          <option [value]="null">All</option>
          <option *ngFor="let course of courses" [value]="course.id">{{ course.name }}</option>
        </select>
        <small *ngIf="isLoadingCourses" class="form-text text-muted">
          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Loading courses...
        </small>
      </div>
      <div class="filter-group">
        <label class="filter-label">Subject</label>
        <select class="form-select" [(ngModel)]="selectedSubjectId" (change)="onSubjectChange()" [disabled]="isLoadingSubjects || isLoadingCourses">
          <option [value]="null">All</option>
          <option *ngFor="let subject of subjects" [value]="subject.id">{{ subject.name }}</option>
        </select>
        <small *ngIf="isLoadingSubjects" class="form-text text-muted">
          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Loading subjects...
        </small>
      </div>
    </div>
  </div>

  <!-- Results panel -->
  <div class="panel results-panel">
    <div class="results-panel-header">
      <label class="panel-label mb-0">Results</label>
      <span class="results-badge" *ngIf="hasSearched">{{ results.length }}</span>
    </div>
    <div class="results-panel-body">
      <div *ngIf="!hasSearched && !isSearching" class="alert alert-info mb-0">
        Select filters above to search for your comments.
      </div>

      <div *ngIf="results.length === 0 && hasSearched && !isSearching" class="alert alert-info mb-0">
        No comments found for the selected filters.
      </div>

      <div *ngIf="isSearching" class="text-center py-4">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        <span>Searching...</span>
      </div>

      <div *ngIf="results.length > 0 && !isSearching">
        <div class="results-list">
          <div *ngFor="let item of paginatedResults"
               class="results-list-item"
               role="button"
               tabindex="0"
               (click)="openDetail(item.questionId)">
            <div class="d-flex w-100 justify-content-between mb-2">
              <h6 class="mb-1">Question #{{ item.questionId }}</h6>
              <small class="text-muted">{{ item.subjectName }}</small>
            </div>
            <p class="mb-1 text-truncate" [title]="resultDisplayHtmlById[item.questionId]">
              {{ getQuestionDisplay(item.questionId) }}
            </p>
            <div class="d-flex justify-content-between align-items-center">
              <p class="mb-0 text-muted comment-preview" [title]="resultCommentHtmlById[item.questionId]">
                {{ getCommentDisplay(item.questionId) }}
              </p>
              <small *ngIf="item.commentCount > 1" class="text-muted ms-2">
                {{ item.commentCount }} comments
              </small>
            </div>
          </div>
        </div>

        <nav *ngIf="results.length > itemsPerPage" aria-label="Results pagination" class="mt-4">
          <ul class="pagination justify-content-center">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a class="page-link" href="#" (click)="previousPage(); $event.preventDefault()" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li *ngFor="let page of pageNumbers" class="page-item" [class.active]="page === currentPage">
              <a class="page-link" href="#" (click)="goToPage(page); $event.preventDefault()">{{ page }}</a>
            </li>
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <a class="page-link" href="#" (click)="nextPage(); $event.preventDefault()" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
          <div class="text-center text-muted small mt-2">
            Showing {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, results.length) }} of {{ results.length }} results
          </div>
        </nav>
      </div>
    </div>
  </div>
</div>

<app-question-detail-modal
  [open]="detailOpen"
  [questionId]="detailQuestionId"
  [questionHtml]="detailQuestionHtml"
  [answersHtml]="detailAnswersHtml"
  [correctAnswer]="detailCorrectAnswer"
  [initialTab]="'comments'"
  (closed)="closeDetail()">
</app-question-detail-modal>
